<ng-template #content let-modal let-close="close" let-dismiss="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Notice</h4>
  </div>
  <div class="modal-body">
    <p>{{ modalOptions().warningText }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close('ok')">
      {{ modalOptions().okText }}
    </button>
  </div>
</ng-template>
<div>
  <button
    class="btn"
    [disabled]="!canClip()"
    [ngClass]="[
      coupon()?.status === 'available' && !isClipping()
        ? getClassString()
        : 'btn-outline-dark'
    ]"
    (click)="isLoggedIn() ? clipCoupon() : redirectTologin()"
  >
    {{ buttonText() }}
  </button>
</div>
